import { gql } from '@apollo/client'

const FULL_USER_FRAGMENT = gql`
    fragment FullUser on User {
        id
        sub
        email
        firstName
        lastName
        picture
        phone
        createdAt
        timezone
        onboardingStatus
        appDomain
        attributionSource
    }
`

export const CURRENT_USER_DATA_QUERY = gql`
    query CurrentUserData {
        me {
            ...FullUser
        }
        growsurfParticipant {
            id
            referralCount
            referralSource
            referralStatus
        }
        growsurfSecret
        rewardsBalance
    }
    ${FULL_USER_FRAGMENT}
`

gql`
    mutation CreateGrowsurfParticipant($referrerId: String) {
        createGrowsurfParticipant(referrerId: $referrerId) {
            id
            referralCount
            referralSource
            referralStatus
        }
    }
`

gql`
    query RewardsBalance {
        rewardsBalance
    }
`

gql`
    query ReferralStats {
        referralStats {
            id
            rewardsEarned
            signups
            qualifiedReferrals
        }
    }
`

gql`
    mutation UpdateCurrentUser($userUpdate: UpdateCurrentUserInput!) {
        updateCurrentUser(userUpdate: $userUpdate) {
            ...FullUser
        }
    }
`

gql`
    mutation UpdateOnboardingStatus($status: OnboardingStatus!) {
        updateOnboardingStatus(status: $status) {
            ...FullUser
        }
    }
`

gql`
    mutation UpdateUserTimezone($timezone: String!) {
        updateUserTimezone(timezone: $timezone) {
            ...FullUser
        }
    }
`

gql`
    mutation UpdateAppDomain($appDomain: AppDomain!) {
        updateAppDomain(appDomain: $appDomain)
    }
`

gql`
    mutation UpdateAttributionSource($attributionSource: String!) {
        updateAttributionSource(attributionSource: $attributionSource) {
            ...FullUser
        }
    }
`

gql`
    mutation AddAssociatedWallet($address: String!) {
        addAssociatedWallet(address: $address)
    }
`
gql`
    mutation AddAffiliateReferralCode($referralCode: String!) {
        addAffiliateReferralCode(referralCode: $referralCode)
    }
`
